// PrivacyPolicy.js
import React from 'react';
import '../styles.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-links">
      <h1>Privacy Policy</h1>
      <p>
        This Privacy Policy explains how information is handled on our website. By using this site, you acknowledge and agree to the terms of this policy.
      </p>

      <h2>1. No Personal Data Collection</h2>
      <p>
        We do not collect, store, or process any personal data from users. This website is purely informational, and no user accounts or forms are involved.
      </p>

      <h2>2. Cookies and Third-Party Services</h2>
      <p>
        Our site may use cookies or similar technologies provided by third-party services like Google AdSense to display relevant advertisements. These services may collect non-personal data such as your IP address, browser type, and browsing activity for ad personalization.
      </p>
      <p>
        You can manage or disable cookies through your browser settings. For more information about how Google uses data, visit:
        <a
          href="https://policies.google.com/technologies/ads"
          target="_blank"
          rel="noopener noreferrer"
        >
          Google Ad Policies
        </a>.
      </p>

      <h2>3. Third-Party Links</h2>
      <p>
        Our website may include links to third-party websites. We are not responsible for their content or privacy practices. Please review the privacy policies of any external sites you visit.
      </p>

      <h2>4. Changes to This Privacy Policy</h2>
      <p>
        We may update this policy as necessary. Any changes will be posted on this page. Your continued use of the site signifies your acceptance of the updated policy.
      </p>

      <h2>5. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy, contact us at:
      </p>
      <p>Email: getfitfast1901@gmail.com</p>
    </div>
  );
};

export default PrivacyPolicy;
